import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmDialogComponent } from './lumilogin/confirm-dialog/confirm-dialog.component';
import { MatDialogRef, MatDialog } from '@angular/material';

export interface CanComponentDeactivate {
	canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
	providedIn: 'root',
})
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {

	unsavedChanges: boolean = false;
	confirmDialogRef: MatDialogRef<ConfirmDialogComponent>;

	constructor(
		private translateService: TranslateService,
		private matDialog: MatDialog
	) { }

	setUnsavedChanges(unsavedChanges: boolean) {
		this.unsavedChanges = unsavedChanges;
	}

	canDeactivate(): Promise<boolean> {
		if (this.unsavedChanges) {
			return this.askConfirmation().then(confirmed => {
				if (confirmed)
					this.unsavedChanges = false;
				return confirmed;
			});
		} else {
			return Promise.resolve(true);
		}
	}

	askConfirmation(): Promise<boolean> {
		let confirmDialogRef = this.matDialog.open(ConfirmDialogComponent, { disableClose: false });
		confirmDialogRef.componentInstance.confirmMessage = this.translateService.instant('CONFIRM_UNSAVED_CHANGES');
		return confirmDialogRef.afterClosed().toPromise().then(confirmed => { return confirmed });
	}
}